import { useQuery } from "@tanstack/react-query";
import { getDirectusField } from "directus/src/operations";
import React from "react";

/**
 * A cell component that fetches and displays the human-readable text for a field choice.
 * Useful for fields with predefined choices in Directus (dropdowns, radios, etc.).
 *
 * @param {Object} props
 * @param {Function} [props.getValue] - TanStack Table getValue function
 * @param {any} [props.value] - Direct value if not using TanStack Table
 * @param {string} props.collection - Directus collection name
 * @param {string} props.field - Directus field name
 */
export const CommonCell = ({ getValue, value, collection, field }) => {
    const raw = value ?? getValue?.();

    const { data: choicesMap } = useQuery({
        queryKey: [collection, field, "choices"],
        queryFn: async () => {
            if (!collection || !field) return {};
            const response = await getDirectusField(collection, field);
            const choices = response?.meta?.options?.choices || [];
            const map = {};
            choices.forEach((c) => {
                if (c?.value != null) map[c.value] = c?.text ?? String(c.value);
            });
            return map;
        },
        enabled: !!collection && !!field && raw != null,
    });

    const label = choicesMap?.[raw] ?? raw ?? "-";
    return <span>{label}</span>;
};

export default CommonCell;
